import { createApi } from '@reduxjs/toolkit/query/react';
import axiosBaseQuery from './axiosBaseQuery';

export const TAG_TYPES = [
  'User Info',
  'User Settings',
  'Invitation',
  'SharedItem',
  'Pricing Information',
] as const;

const baseApi = createApi({
  reducerPath: 'api',
  baseQuery: axiosBaseQuery(),
  tagTypes: TAG_TYPES,
  endpoints: () => ({}),
});

export type EndpointBuilder = Parameters<
  Parameters<typeof baseApi.injectEndpoints>[0]['endpoints']
>[0];

export default baseApi;
